import React, { createContext, useState } from "react";

export const ProfileContext = createContext();

// Holds the village currently being viewed and the image opened from it.
export const ProfileProvider = ({ children }) => {
  const [village, setVillage] = useState({});
  const modifyVillage = (value) => setVillage(value);

  const [selectedImage, setSelectedImage] = useState({});
  const modifySelectedImage = (value) => setSelectedImage(value);

  return (
    <ProfileContext.Provider
      value={{
        village,
        modifyVillage,
        selectedImage,
        modifySelectedImage,
      }}
    >
      {children}
    </ProfileContext.Provider>
  );
};
